import type { OptionMenuItem } from '@getaccept/lib-shared/src/options-menu/types/option-menu-item';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { ResourceSortAttribute } from '@getaccept/lib-shared/src/resources/types/enum/resource-sort-attribute';
import { SortOrder } from '@getaccept/fried-tofu';
import { TemplateGalleryOptions } from '../enums/template-gallery';
import type { LoadGlobalResourcesFilter } from '../types/load-resources-filter';
export class TemplateGalleryConstants {
  private static readonly documentIcon = 'document-create';
  static templateGalleryActions = (): OptionMenuItem[] => [
    {
      title: t('preview-template'),
      icon: 'document-search',
      callback: TemplateGalleryOptions.Preview,
    },
    {
      title: t('template-gallery-save-template'),
      icon: 'add-square',
      callback: TemplateGalleryOptions.Copy,
    },
    {
      title: t('template-gallery-start-sendout'),
      icon: TemplateGalleryConstants.documentIcon,
      callback: TemplateGalleryOptions.Send,
    },
    {
      title: t('template-gallery-add-to-template'),
      icon: TemplateGalleryConstants.documentIcon,
      callback: TemplateGalleryOptions.Use,
    },
    {
      title: t('template-gallery-add-to-document'),
      icon: TemplateGalleryConstants.documentIcon,
      callback: TemplateGalleryOptions.Use,
    },
  ];

  static defaultFilter: LoadGlobalResourcesFilter = {
    searchTerms: [],
    limit: 30,
    offset: 0,
    sortBy: ResourceSortAttribute.CreatedAt,
    sortOrder: SortOrder.Desc,
  };
}
